export default "__VITE_ASSET__a7d1fdc5__"